import { Alert, Container, Snackbar } from "@mui/material";
import { useState } from "react";
import { VisorOrdenExterna } from "../components/VisorOrdenExterna";

const VisorOrdenExternaPage = () => {
  const [message, setMessage] = useState({
    open: false,
    message: null,
    severity: 'success'
  });
  return (
    <Container maxWidth="md">
      <VisorOrdenExterna
        message={message}
        setMessage={setMessage}
      />
      
      {/* Snackbar para mensajes */}
      <Snackbar
        open={message.open}
        autoHideDuration={6000}
        onClose={() => setMessage({ ...message, open: false })}
      >
        <Alert severity={message.severity} onClose={() => setMessage({ ...message, open: false })} style={{ overflowWrap: 'anywhere'}}>
          {message.message}
        </Alert>
      </Snackbar>
    </Container>
  );
};
export default VisorOrdenExternaPage;